import { render, staticRenderFns } from "./PlayProject.vue?vue&type=template&id=2526ccf1&scoped=true&lang=pug&"
import script from "./PlayProject.vue?vue&type=script&lang=js&"
export * from "./PlayProject.vue?vue&type=script&lang=js&"
import style0 from "./PlayProject.vue?vue&type=style&index=0&id=2526ccf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526ccf1",
  null
  
)

export default component.exports